import { render, staticRenderFns } from "./TriggerTypePreview.vue?vue&type=template&id=5d8af3c5"
import script from "./TriggerTypePreview.vue?vue&type=script&lang=js"
export * from "./TriggerTypePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports